<template>

    <div class="notams-main">

        <div v-for="post in DataList" :key="post.idx">
            <div v-for="p in post.NotamInfoList" :key="p.idx">
                <pre v-html="getValueWithImportantWord(p.NotamInfo)"></pre>
            </div>
        </div>

<!--        <div v-for="post in WR_Json_Data.LIST_USED_AIRPORTS" :key="post.idx">-->
<!--            <div v-for="p in post.NotamInfoList" :key="p.idx">-->
<!--                <pre>{{p.NotamInfo}}</pre>-->
<!--            </div>-->
<!--        </div>-->

    </div>

</template>

<script>
    import {loadingMixin} from "../../../../utils/mixins";
    import {mapState , /*mapActions, mapGetters*/} from "vuex";
    import ScheduleService from "../../../../services/schedule.service";

    export default {
        name: "notams",
        mixins: [loadingMixin],
        props: ["id", "flight"],
        data() {
            return {
                notamdata : "",

            }
        },
        computed : {
            ...mapState("ipadmain", [/*"FKey1",*/ "selectedFlightItems", "EFF_Json_Data", "WR_Json_Data","NotamImportantList"]),

            DataList: function () {

                if (this.WR_Json_Data != null) {

                    return this.WR_Json_Data.LIST_USED_AIRPORTS;
                } else {
                    return "";
                }
            },
        },

        async created() {
          // await this.GetJsonDataR();
        },
        methods : {

            async getNotamImportantWordList()
            {
                var wordlist= await ScheduleService.GetNotamImportantList();
                this.NotamImportantList = wordlist;
            },

            getValueWithImportantWord(value)
            {
                var i;
                for (i = 0; i < this.NotamImportantList.length; i++) {

                    this.NotamImportantList[i]
                    value=value.replaceAll(this.NotamImportantList[i].word.toString().toUpperCase(),"<span style='color: "+this.NotamImportantList[i].color+";font-weight: '"+this.NotamImportantList[i].style+"'>"+this.NotamImportantList[i].word.toString().toUpperCase()+"</span>");

                }

                return value;
            }

        }

    }
</script>

<style scoped>
    .content {
        width: 100%;
        height: 900px;
    }
    .notem-text{
        font-size: 1.1em;
    }
</style>
